import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared';
import { UIRouterModule } from '@uirouter/angular';
import { CustomerAdminRoute } from './customer-admin.route';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as reducer from './store/company-info/company-info.reducer';
import * as advisorreducer from './store/advisors/advisor.reducer';
import { CompanyInfoEffects } from './store/company-info/company-info.effects';
import { AdvisorEffects } from './store/advisors/advisor.effects';

@NgModule({
    providers: [],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [CustomerAdminRoute]
        }),
        StoreModule.forFeature(advisorreducer.advisorFeatureKey, advisorreducer.reducer),
        StoreModule.forFeature(reducer.companyInfoFeatureKey, reducer.reducer),
        EffectsModule.forFeature([CompanyInfoEffects, AdvisorEffects])
    ]
})
export class CustomerAdminModule {
    constructor() {}
}
